var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 88,
    viewBox: "0 0 296 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0192 38.1709H57.4639V42.2853H40.0192V38.1709Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0192 31.314H57.4639V35.4284H40.0192V31.314Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0192 24.457H57.4639V28.5714H40.0192V24.457Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3275 17.6L42.3016 21.7144H60.1487V39.9537L64.1741 35.8398V17.6H46.3275Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.04 27.5724C153.96 26.7397 152.312 26.1403 150.741 26.1403C146.567 26.1403 144.291 30.5574 144.291 34.7213C144.291 36.9328 144.79 40.5157 148.376 40.5157C148.913 40.5157 149.355 40.4576 149.804 40.3221L150.624 34.3854H155.177L154.222 41.2935C152.076 42.1864 150.211 42.5347 147.956 42.5347C142.816 42.5347 139.688 39.8787 139.688 34.7692C139.688 29.3963 143.334 24.2084 150.489 24.2084C152.368 24.2084 153.949 24.6089 155.599 25.434L155.04 27.5724Z",
    fill: "#181716"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6405 42.2863L94.0575 24.4769L89.4579 24.4568L87.0414 42.2663L91.6405 42.2863Z",
    fill: "#181716"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2428 26.3771L85.5079 24.457H75.3601L72.8959 42.285H83.0447L83.3098 40.3648H77.7139L78.6086 33.8911H83.8011L84.0378 32.1768H78.8458L79.6469 26.3771H85.2428Z",
    fill: "#181716"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.885 26.3771L170.151 24.457H160.002L157.538 42.285H167.686L167.951 40.3648H162.356L163.25 33.8911H168.443L168.679 32.1768H163.487L164.289 26.3771H169.885Z",
    fill: "#181716"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.679 26.3771L108.945 24.457H98.7965L96.3328 42.285H100.885L102.046 33.8911H107.238L107.475 32.1768H102.282L103.084 26.3771H108.679Z",
    fill: "#181716"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.548 26.3771L122.814 24.457H112.665L110.202 42.285H114.754L115.914 33.8911H121.106L121.343 32.1768H116.151L116.952 26.3771H122.548Z",
    fill: "#181716"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.033 42.2851H137.329L133.676 24.4496H130.537L120.67 42.2851H123.148L126.306 36.594H131.85L133.033 42.2851ZM127.257 34.8792L130.341 29.3231L131.494 34.8792H127.257Z",
    fill: "#181716"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 64,
    width: 24,
    height: 24,
    fill: "#FF0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 64,
    width: 24,
    height: 24,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 64,
    width: 24,
    height: 24,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 64,
    width: 24,
    height: 24,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 64,
    width: 24,
    height: 24,
    fill: "#FF0000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 24,
    height: 24,
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.639e58965739cbce5362d6ed2aa5b472.svg";
export { ForwardRef as ReactComponent };